/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as ShareworksIndexImport } from './routes/shareworks/index';
import { Route as PreviewIndexImport } from './routes/preview/index';
import { Route as IntranetIndexImport } from './routes/intranet/index';
import { Route as FreestandingIndexImport } from './routes/freestanding/index';
import { Route as DownloadMultiplePdfIndexImport } from './routes/downloadMultiplePdf/index';
import { Route as PathlessRouteCompanyNameImport } from './routes/_pathlessRoute/$companyName';

// Create/Update Routes

const ShareworksIndexRoute = ShareworksIndexImport.update({
  path: '/shareworks/',
  getParentRoute: () => rootRoute,
} as any);

const PreviewIndexRoute = PreviewIndexImport.update({
  path: '/preview/',
  getParentRoute: () => rootRoute,
} as any);

const IntranetIndexRoute = IntranetIndexImport.update({
  path: '/intranet/',
  getParentRoute: () => rootRoute,
} as any);

const FreestandingIndexRoute = FreestandingIndexImport.update({
  path: '/freestanding/',
  getParentRoute: () => rootRoute,
} as any);

const DownloadMultiplePdfIndexRoute = DownloadMultiplePdfIndexImport.update({
  path: '/downloadMultiplePdf/',
  getParentRoute: () => rootRoute,
} as any);

const PathlessRouteCompanyNameRoute = PathlessRouteCompanyNameImport.update({
  path: '/$companyName',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_pathlessRoute/$companyName': {
      preLoaderRoute: typeof PathlessRouteCompanyNameImport;
      parentRoute: typeof rootRoute;
    };
    '/downloadMultiplePdf/': {
      preLoaderRoute: typeof DownloadMultiplePdfIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/freestanding/': {
      preLoaderRoute: typeof FreestandingIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/intranet/': {
      preLoaderRoute: typeof IntranetIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/preview/': {
      preLoaderRoute: typeof PreviewIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/shareworks/': {
      preLoaderRoute: typeof ShareworksIndexImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  PathlessRouteCompanyNameRoute,
  DownloadMultiplePdfIndexRoute,
  FreestandingIndexRoute,
  IntranetIndexRoute,
  PreviewIndexRoute,
  ShareworksIndexRoute,
]);

/* prettier-ignore-end */
